<script lang="ts">
  import { Cancellation, cancellationTotal, notToBeRefunded, toBeRefunded } from "@models/cancellations/Cancellation"
  import { formatCentsAsUsd } from "@util/money"

  export let cancellation: Cancellation
  export let insuranceOnly: boolean
</script>

<div id="amounts-overview" role="status" class="grid sm:grid-cols-3 border-y mt-16 p-8 pb-16 sm:pb-8 gap-block-8">
  <div class="sm:col-span-3 text-center sm:hidden mt-8 text-sm">Refund Totals:</div>
  <div class="text-center">
    <div class="text-xxl" data-role="paid-amount" data-testid="paid-amount">
      {formatCentsAsUsd(cancellationTotal(cancellation))}
    </div>
    <div data-role="description">Paid (incl. fees)</div>
  </div>
  <div class="text-center">
    <div class="text-xl absolute mt-2 h-8 w-8 rounded-full leading-7 font-light">-</div>
    <div class="text-xxl" data-testid="non-refundable-amount" data-role="non-refundable-amount">
      {formatCentsAsUsd(notToBeRefunded(cancellation, insuranceOnly))}
    </div>
    <div data-role="description">Non Refundable</div>
  </div>
  <div class="text-center">
    <div class="text-xl absolute mt-2 h-8 w-8 rounded-full leading-7 font-light">=</div>
    <div class="text-xxl font-bold" data-testid="refundable-amount" data-role="refundable-amount">
      {formatCentsAsUsd(toBeRefunded(cancellation, insuranceOnly))}
    </div>
    <div class="font-bold" data-role="description">To Be Refunded</div>
  </div>
</div>
